export const isMac = window.navigator.platform.toLowerCase().includes('mac');
